export const ConsumptionHistoryTabsIds = {
  ESIGN: 'esign',
  STAMP: 'stamp',
};
